import moment from 'moment';
import 'moment/locale/is';

export function getToday() {
  var mom = moment().utc().startOf('date');
  return mom;
}

export function convertStrToUtcDate(str) {
  var mom = moment.utc(str);
  return mom;
}

export function firstDayOfNextMonth() {
  var mom = getToday();
  mom.add(1, 'month').startOf('month');
  return mom;
}

export function lastDayOfThisMonth() {
  var mom = getToday();
  mom.endOf('month');
  return mom;
}

export function addDays(date, days) {
  var clone = moment(date);
  clone.add(days, 'days');
  return clone;
}

export function dateEquals(date1, date2) {
  return moment(date1).startOf('date').isSame(moment(date2).startOf('date'));
}

export function parseDate(dateString) {
  return moment(dateString, 'YYYY-MM-DD').utc();
}

export const getFirstWorkDayOfMonth = () => {
  const today = getToday();
  const firstDayOfMonth = moment(today).startOf('month');

  while (firstDayOfMonth.day() === 0 || firstDayOfMonth.day() === 6) {
    firstDayOfMonth.add(1, 'day');
  }

  if (firstDayOfMonth.isBefore(today, 'day')) {
    const firstDayOfNextMonth = moment(today).add(1, 'month').startOf('month');
    while (firstDayOfNextMonth.day() === 0 || firstDayOfNextMonth.day() === 6) {
      firstDayOfNextMonth.add(1, 'day');
    }
    return firstDayOfNextMonth;
  }

  return firstDayOfMonth;
};
